import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input} from 'reactstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';

import ErrorMsg from "../common/ErrorMsg";
import {getUser} from "../../utils/TokenManager";
import {downloadPDF} from "../common/Constants";
import StaffDashboardService from "../../services/StaffDasboardService";
import AddAchievementModal from "./AddAchievementModal";
import RequestCorrectionModal from "./RequestCorrectionModal";
import LoadingModal from "../common/LoadingModal";
import CorrectionLog from "../staffData/CorrectionsLog";


const heading_name_list = [
    'first_heading', 'second_heading', 'third_heading', 
    'forth_heading', 'fifth_heading'
];

export default class StaffDataList extends Component {
    state = {
        headings: [],
        achievementList: [],
        totalAchievement: 0,
        kpiDefinition: '',
        startDate: "",
        endDate: "",
        adminAchievementFilter: false,
        isFilterEnable: false,
        openAddAchievementModal: false,
        openCorrectionModal: false,
        achievementSelected: {},
        viewCorrection: false,
        isAchievementSelected: false,
        isLoading: false,
        searchString: '',
        totalPage: 0,
        currentPage: 1,
        nextPageNo: null,
        prevPageNo: null,
        isCorrectionLogOpen: false,
        currentUser: {}
    };

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        if (!(isEmpty(this.props.selectedKPI))) {
            try {
                let result = await StaffDashboardService.getKPIHeadings(
                    this.props.selectedKPI.kpi_list_id
                );

                let headings = [];
                if (200 === result.status) {
                    headings = result.data.kpi_headings.map((heading) => ({...heading}));
                    this.setState({headings});
                }
            } catch (error) {
                console.log(error);
            }
            try {
                let result = await StaffDashboardService.getAchievementList(
                    this.props.selectedKPI.kpi_list_id
                );

                let achievementList = [], totalAchievement, totalPage = 0;
                if (200 === result.status) {
                    totalAchievement = result.data.total_achievements;
                    totalPage = Math.ceil(result.data.count / result.data.page_size)
                    achievementList = result.data.achievements.map((data) => ({...data}));
                    this.setState({
                        achievementList, totalAchievement, totalPage,
                        currentPage: result.data.page,
                        nextPageNo: result.data.next,
                        prevPageNo: result.data.previous
                    });
                }
            } catch (error) {
                console.log(error);
            }
            try {
                let result = await StaffDashboardService.getKPIDetails(
                    this.props.selectedKPI.kpi_list_id
                );

                if (200 === result.status) {
                    let kpiDefinition = result.data.definition;
                    this.setState({kpiDefinition});
                }
            } catch (error) {
                console.log(error);
            }
        }
        return false;
    };

    toggleModal = () => {
        this.setState({
            headings: [],
            achievementList: []
        }, () => this.props.toggleModal());
    };

    handleChange = (e) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let achievementData = {...this.state.achievementData};
        achievementData[name] = value;
        this.setState({achievementData});
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date, field) => {
        if (field === "startDate") {
            this.setState({startDate: date});
        } else {
            this.setState({endDate: date});
        }
    };

    handleAdminFilter = () => {
        this.setState(prevState => ({
            adminAchievementFilter: !prevState.adminAchievementFilter,
            currentPage: 1
        }), () => this.filterKPIWithDateRange());
    }

    filterKPIWithDateRange = async () => {
        const {
            startDate, endDate, searchString, currentPage, adminAchievementFilter
        } = this.state;
        let newStartDate = moment(startDate).format("YYYY-MM-DD");
        let newEndDate = moment(endDate).format("YYYY-MM-DD");

        try {
            let result = await StaffDashboardService.getAchievementList(
                this.props.selectedKPI.kpi_list_id, 
                newStartDate, newEndDate, searchString, 
                adminAchievementFilter, currentPage
            );
            let achievementList = [], totalAchievement, totalPage = 0;
            if (200 === result.status) {
                totalAchievement = result.data.total_achievements;
                totalPage = Math.ceil(result.data.count / result.data.page_size)
                achievementList = result.data.achievements.map((data) => ({...data}));
                this.setState({
                    achievementList, totalAchievement, totalPage,
                    currentPage: result.data.page,
                    nextPageNo: result.data.next,
                    prevPageNo: result.data.previous
                });
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }

        this.setState({
            allKPIData: this.props.kpiList
        });
    };

    filterKPIData = (e, isFiltered) => {
        e.preventDefault();
        this.setState({isFilterEnable: isFiltered});

        if (!isFiltered) {
            this.setState({
                startDate: "",
                endDate: "",
                searchString: "",
                currentPage: 1,
                adminAchievementFilter: false
            }, () => (this.filterKPIWithDateRange()));
        } else {
            this.setState({currentPage: 1}, () => this.filterKPIWithDateRange());
        }
    };

    getPageData = (page=1) => {
        this.setState({currentPage: page}, () => this.filterKPIWithDateRange());
    }

    toggleAddAchievementModal = () => {
        this.setState((prevState) => (
            {openAddAchievementModal: !prevState.openAddAchievementModal}
        ));
    };

    openAddAchievementModal = () => {
        this.setState({openAddAchievementModal: true});
    };

    // Update scores after adding achievement
    updateAchievement = (achievementData, requiredHeadingData, wantToClose, canToggle) => {
        achievementData['added_on'] = moment(achievementData.added_on).format("MM/DD/YYYY");
        let achievementList = [achievementData, ...this.state.achievementList];
        let {totalAchievement} = this.state;
        // check kpi formula type and calculate score accordingly
        if (this.props.selectedKPI.kpi_property_formula === "Add") {
            if (isNaN(requiredHeadingData)) {
                totalAchievement += 0;
            } else {
                totalAchievement += parseFloat(requiredHeadingData);
            }
        } else {
            totalAchievement ++;
        }
        this.setState({achievementList, totalAchievement});
        this.props.updateAchievement(achievementData, requiredHeadingData, wantToClose, false);
        if (wantToClose) {
            this.toggleAddAchievementModal();
        }
    };

    toggleCorrectionModal = () => {
        this.setState((prevState) => ({openCorrectionModal: !prevState.openCorrectionModal}));
    };

    openCorrectionModal = async (viewCorrection) => {
        if (!viewCorrection) {
            if(!this.state.isAchievementSelected) {
                toast.error("Please select a row first.");
                return false;
            }
            try {
                let result = await StaffDashboardService.checkRecordInCorrectionList(
                    this.state.achievementSelected.id
                );

                if (200 === result.status && result.data.does_exist) {
                    toast.error(
                        "This record is already in correction requests queue.",
                        {
                            autoClose: 3000,
                            className: 'toast-width'
                        }
                    );
                    return false;
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
        }
        this.setState({openCorrectionModal: true, viewCorrection});
    };

    handleRowSelect = (row, isSelected, e) => {
        if (isSelected) {
            this.setState({achievementSelected: row, isAchievementSelected: isSelected});
        } else {
            this.setState({isAchievementSelected: false});
        }
    };

    generatePDF = async() => {
        try {
            this.setState({isLoading: true});
            const {startDate, endDate, searchString, adminAchievementFilter} = this.state;
            let result;
            if (this.state.isFilterEnable) {
                let newStartDate = moment(startDate).format("YYYY-MM-DD");
                let newEndDate = moment(endDate).format("YYYY-MM-DD");

                result = await StaffDashboardService.getAchievementPDF(
                    this.props.selectedKPI.kpi_list_id, newStartDate, newEndDate, searchString,
                    adminAchievementFilter
                );
            } else {
                result = await StaffDashboardService.getAchievementPDF(
                    this.props.selectedKPI.kpi_list_id, "", "", "", adminAchievementFilter
                );
            }
            
            if (200 === result.status) {
                let content = result.data.content;
                let fileName = result.data.file_name;
                downloadPDF(content, fileName);
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }
        this.setState({isLoading: false});
    }

    handleSearchChange = (e) => {
        this.setState({searchString: e.currentTarget.value});
    };

    headingFormatter = (cell, row, heading) => {
        if (heading.has_property) {
            const {selectedKPI} = this.props;
            if (selectedKPI.data_type === "Percentage") {
                return <NumberFormat value={cell} displayType={'text'} 
                            thousandSeparator={true} decimalScale={2} suffix={' %'} 
                        />;
            } else if (selectedKPI.data_type === "Currency") {
                return <NumberFormat value={cell} displayType={'text'} 
                            thousandSeparator={true} decimalScale={2} prefix={'$ '} 
                        />;
            } else {
                return <NumberFormat value={cell} displayType={'text'} 
                            thousandSeparator={true} decimalScale={2} 
                        />;
            }
        } else {
            return cell;
        }
    }

    sortDates (a, b, order) {
        let indices = [6, 7, 8, 9, 0, 1, 3, 4];
        if (order === 'asc') {
          let r = 0;
          indices.find(i => r = a.added_on.charCodeAt(i) - b.added_on.charCodeAt(i));
          return r;
        } else if (order === 'desc') {
          let r = 0;
          indices.find(i => 
            r = b.added_on.toString().charCodeAt(i) - a.added_on.toString().charCodeAt(i));
          return r;
        }
    }

    openCorrectionLogModal = () => {
        let userDetails = getUser();
        this.setState({isCorrectionLogOpen: true, currentUser: userDetails});
    }

    toggleCorrectionLogModal = () => {
        this.setState({isCorrectionLogOpen: false});
    }

    render() {
        const {
            headings, achievementList, kpiDefinition, startDate, endDate, 
            isFilterEnable, totalPage, nextPageNo, prevPageNo, currentPage, 
            totalAchievement, openAddAchievementModal, openCorrectionModal, 
            achievementSelected, viewCorrection, searchString, 
            isCorrectionLogOpen, currentUser, adminAchievementFilter
        } = this.state;
        const {selectedKPI} = this.props;
        let headingList = [];
        headingList.push( 
            <TableHeaderColumn key={11} dataField='id' isKey={true} hidden>#</TableHeaderColumn>
        );
        headingList.push( 
            <TableHeaderColumn key={10} dataField="added_on" 
                dataSort={true} sortFunc={this.sortDates} width="110px"
            >Date</TableHeaderColumn>
        );
        headings.map((heading, index) => {
            let heading_name = '';
            if (index < 5) {
                heading_name = heading_name_list[index];
            } 
            headingList.push( 
                <TableHeaderColumn key={index} dataField={heading_name} 
                    dataSort={true} headerText={heading.heading} 
                    dataFormat={(cell, row) => this.headingFormatter(cell, row, heading)}
                >{heading.heading} {heading.has_property && 
                    <span className="text-danger" 
                        title="This field data will be used to calculate total achievements."
                    >*</span>}
                </TableHeaderColumn>
            );
        });
        // Handle on click of any row
        const options = {
            defaultSortName: 'added_on',
            defaultSortOrder: 'desc'
        };
        const selectRow = {
            mode: 'radio',
            clickToSelect: true,
            onSelect: this.handleRowSelect,
            bgColor: 'rgba(85,119,191,0.5)',
            className: 'selected-row'
        };
        
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal} size="lg">
                <ModalHeader toggle={this.toggleModal}>
                    Achievement Data of KPI `{selectedKPI.kpi_name}`
                </ModalHeader>
                <div className="bg-secondary py-2 pl-3">
                    <ul className="secondary-menu">
                        <li onClick={() => this.openCorrectionModal(false)}>
                            <a href="javascript:">Request Correction</a>
                        </li>
                        <li onClick={this.openCorrectionLogModal}>
                            <a href="javascript:">View Corrections</a>
                        </li>
                        <li onClick={this.generatePDF}>
                            <a href="javascript:">Print Achievements</a>
                        </li>
                        {selectedKPI.show_on_dashboard ?
                            <li onClick={this.openAddAchievementModal}>
                                <a href="javascript:">Add Achievement</a>
                            </li>
                            : null
                        }
                    </ul>
                </div>
                <ModalBody>
                    <div className="mb-3">
                        <Input type="textarea" className="form-control" name="definition" 
                            rows="3" value={kpiDefinition} disabled={true} />
                    </div>
                    <form>
                    <div className="row mb-2">
                        <div className="col-6 col-sm-1 pr-0 mb-2">
                            <label className="mb-0">KPI Goal</label>
                            {selectedKPI.data_type === "Percentage" ?
                                <NumberFormat value={selectedKPI.total_goal} 
                                    thousandSeparator={true} decimalScale={2} 
                                    suffix={'%'} className="form-control" disabled={true}
                                    title={`${selectedKPI.total_goal}%`} 
                                />
                            : selectedKPI.data_type === "Currency" ?
                                <NumberFormat value={selectedKPI.total_goal} 
                                    thousandSeparator={true} decimalScale={2} 
                                    prefix={'$'} className="form-control" disabled={true} 
                                    title={`$${selectedKPI.total_goal}`}
                                />
                            :
                                <NumberFormat value={selectedKPI.total_goal} 
                                    thousandSeparator={true} decimalScale={2} 
                                    className="form-control" disabled={true} 
                                    title={selectedKPI.total_goal}
                                />
                            }
                        </div>
                        <div className="col-6 col-sm-1 pr-0 mb-2">
                            <label className="mb-0">Per Week</label>
                            {selectedKPI.data_type === "Percentage" ?
                                <NumberFormat value={Math.ceil(selectedKPI.goal_per_week)} 
                                    thousandSeparator={true} decimalScale={0} 
                                    suffix={'%'} className="form-control" disabled={true} 
                                />
                            : selectedKPI.data_type === "Currency" ?
                                <NumberFormat value={Math.ceil(selectedKPI.goal_per_week)} 
                                    thousandSeparator={true} decimalScale={0} 
                                    prefix={'$'} className="form-control" disabled={true} 
                                    title={`$${Math.ceil(selectedKPI.goal_per_week)}`}
                                />
                            :
                                <NumberFormat value={Math.ceil(selectedKPI.goal_per_week)} 
                                    thousandSeparator={true} decimalScale={0} 
                                    className="form-control" disabled={true} 
                                />
                            }
                        </div>
                        <div className="col-6 col-sm-2 pr-0 mb-2">
                            <label className="mb-0">From date</label>
                            <div className="div-datepicker">
                                <DatePicker
                                    selected={startDate}
                                    onChangeRaw={this.handleDateChangeRaw}
                                    onChange={(event) => this.handleDateChange(event, "startDate")}
                                    dateFormat="MM/DD/YYYY"
                                    fixedHeight showMonthDropdown
                                    showYearDropdown dropdownMode="select"
                                    className="form-control"
                                    minDate={moment('2012-01-01')}
                                    maxDate={moment().add(5, 'years')}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-6 col-sm-2 pr-0 mb-2">
                            <label className="mb-0">To date</label>
                            <div className="div-datepicker">
                                <DatePicker
                                    selected={endDate}
                                    onChangeRaw={this.handleDateChangeRaw}
                                    onChange={(event) => this.handleDateChange(event, "endDate")}
                                    fixedHeight dateFormat="MM/DD/YYYY"
                                    showMonthDropdown showYearDropdown
                                    dropdownMode="select"
                                    className="form-control"
                                    minDate={moment(startDate)}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-sm-3 pr-0 mb-2">
                            <label className="mb-0">Search for data in achievements</label>
                            <input type="text" className="form-control" name="search_string" 
                                value={searchString} onChange={this.handleSearchChange} />
                        </div>
                        <div className="col-6 col-sm-1 pr-0 mb-2">
                            <br />
                            <button type="submit" className="btn btn-success btn-block px-2" 
                                onClick={(e) => this.filterKPIData(e, true)}
                            ><i className="fa fa-search"></i>&nbsp;Filter
                            </button>
                        </div>
                        <div className="col-6 col-sm-2 mb-2">
                            <br />
                            <button className={isFilterEnable ? 
                                    "btn btn-warning btn-block" : "d-none"} 
                                onClick={(e) => this.filterKPIData(e, false)}
                            >Clear Filter</button>
                        </div>
                        {/* <div className="col-12 mb-2">
                            <label className="mb-0 d-flex align-items-center cursor-pointer">
                                <input type="checkbox"
                                    value={adminAchievementFilter}
                                    checked={adminAchievementFilter}
                                    onChange={this.handleAdminFilter}
                                /> 
                                <span className="pl-2">
                                    Administrative Achievement
                                </span>
                            </label>
                        </div> */}
                    </div>
                    </form>
                    <BootstrapTable data={achievementList} striped hover condensed 
                        options={options} bodyStyle={{background: '#ffffff'}} 
                        tableBodyClass='bst-body'  tableHeaderClass='bst-header' 
                        selectRow={selectRow} maxHeight='320px' version='4'
                    >
                        {headingList}
                    </BootstrapTable>
                    {achievementList.length > 0 &&
                        <nav aria-label="..." className="p-2">
                            <ul className="pagination pagination-sm float-left mb-2">
                                {prevPageNo && <React.Fragment>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(1)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            First
                                        </a>
                                    </li>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(prevPageNo)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            {'<<'}
                                        </a>
                                    </li>
                                </React.Fragment>}
                                <li className="page-item active">
                                    <a className="page-link" href="javascript:">
                                        {currentPage} of {totalPage}
                                    </a>
                                </li>
                                {nextPageNo && <React.Fragment>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(nextPageNo)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            {'>>'}
                                        </a>
                                    </li>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(totalPage)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            Last
                                        </a>
                                    </li>
                                </React.Fragment>}
                            </ul>
                            <span className="font-weight-bold float-right p-1">
                                Total Achievements: &nbsp;
                                {selectedKPI.data_type === "Percentage" ?
                                    <NumberFormat value={totalAchievement} 
                                        displayType={'text'} thousandSeparator={true} 
                                        decimalScale={2} suffix={' %'}/>
                                    : selectedKPI.data_type === "Currency" ?
                                        <NumberFormat value={totalAchievement} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} prefix={'$'}/>
                                    :
                                        <NumberFormat value={totalAchievement} displayType={'text'} 
                                            thousandSeparator={true} decimalScale={2}/>
                                }
                            </span>
                        </nav>
                    }
                    {openAddAchievementModal && 
                        <AddAchievementModal {...this.props} modal={openAddAchievementModal} 
                            toggleModal={this.toggleAddAchievementModal} 
                            selectedKPI={selectedKPI} updateAchievement={this.updateAchievement} 
                            periodStartDate={this.props.periodStartDate} 
                        />
                    }
                    {openCorrectionModal && 
                        <RequestCorrectionModal {...this.props} modal={openCorrectionModal} 
                            toggleModal={this.toggleCorrectionModal} 
                            selectedKPI={selectedKPI} achievementSelected={achievementSelected} 
                            headings={headings} viewCorrection={viewCorrection} 
                            periodStartDate={this.props.periodStartDate} 
                        />
                    }
                    {this.state.isLoading && <LoadingModal modal={this.state.isLoading} />}
                    {isCorrectionLogOpen &&
                        <CorrectionLog {...this.props} 
                            modal={isCorrectionLogOpen}
                            toggleModal={this.toggleCorrectionLogModal}
                            selectedUser={currentUser} 
                            staffDashboard={true}
                            selectedKPI={selectedKPI}
                        />
                    }
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffDashboard/StaffDataList.js